import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';
import { ToastContainer, toast, cssTransition } from 'react-toastify';

import { APIHandler, StorageHandler, BackVideo, DataHandler } from 'C4';
import { storageKeys, bgVideo } from 'settings';

import 'react-toastify/dist/ReactToastify.css';
import Logo from 'assets/images/logo/logo.png';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      unreadMessageCount: 0,
      lastCheckedMessages: '',
      appId: -1,
      userStatus: 'startTraining'
    };
  }

  componentWillMount() {
    document.body.classList.add('no-scroll');
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res) {
        this.setState({ lastCheckedMessages: res });
      }
      this.checkForUnreadMessages();
    });

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res.response.training_graduated) {
        return this.setState({ userStatus: 'graduated' });
      }
      if (res.response.training_started) {
        return this.setState({ userStatus: 'continueTraining' });
      }
      return this.setState({ userStatus: 'startTraining' });
    });
  }

  componentDidMount() {
    const d = new Date(Date.now());
    const leading = val => `0${val}`.slice(-2);

    StorageHandler.load(storageKeys.user).then((user) => {
      if (user && user.response.sales_companion_registered === null) {
        const obj = user;
        const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate(),
        )}`;
        DataHandler.matchAppId().then((appId) => {
          APIHandler.updateUser(appId, obj.response.email, [
            { param: 'sales_companion_registered', val: date },
          ]).then((res) => {
            if (res) {
              obj.response.sales_companion_registered = date;
              StorageHandler.save(storageKeys.user, obj);
            }
          });
        });
      }
    });
    DataHandler.matchAppId().then((appId) => {
      this.setState({ appId });
      StorageHandler.exists(storageKeys.announcement).then(announcementShownBefore => {
          if (!announcementShownBefore) {
            APIHandler.getAnnouncement(appId).then((res) => {
              const TaostContent = () => (
                <div>
                  <p>
                    {res.copy}
                    <a
                      data-fancybox="rewards"
                      data-type="iframe"
                      data-src={`https://perurewards.travpromobile.com/?app_id=${appId}`}
                      href={`https://perurewards.travpromobile.com/?app_id=${appId}`}
                      key="rewards"
                    >
                      {i18n.translate('general.rewards')}
                    </a>
                  </p>
                </div>
              );

              if (res.length !== 0) {
                toast.info(TaostContent, {
                  position: 'top-center',
                  autoClose: false,
                  closeOnClick: true,
                  transition: Zoom,
                  hideProgressBar: true,
                  pauseOnHover: true,
                  draggable: true,
                  toastId: 'announcement',
                  onClose: () =>
                    StorageHandler.save(
                      storageKeys.announcement,
                      res.copy,
                      604800,
                    ), // expires in a week
                });
              }
              return null;
            });
          }
        },
      );
    });
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  checkForUnreadMessages() {
    DataHandler.requestWithId(
      APIHandler.getUnreadMessages,
      this.state.lastCheckedMessages,
    ).then((res) => {
      this.setState({ unreadMessageCount: res.missed_items[0].count });
    });
  }

  render() {
    const { userStatus, unreadMessageCount } = this.state;
    return (
      <div className="homeContainer">
        <div className="homeLine" />
        {bgVideo && <BackVideo />}
        <Spring
          from={{ transform: 'translateY(30%)', opacity: 0 }}
          to={{ transform: 'translateY(0%)', opacity: 1 }}
        >
          {props => (
            <div className="homeView" style={props}>
              <div className="homeView__title">
                <img src={`/${Logo}`} className="homeLogo" alt="logo" />

                {/* <div className="homeLogo">
                  <Logo />
                </div> */}

                {/* <h1>{i18n.translate('homeScreen.title')}</h1> */}
                <div className="homeView__title--action">
                  <form>
                    <Link
                      to="/main/search"
                      onClick={() => {
                        this.setQuery();
                      }}
                    >
                      <button type="submit" className="searchButton">
                        <FontAwesomeIcon icon={['fas', 'search']} />
                      </button>
                    </Link>
                    <input
                      type="text"
                      placeholder={i18n.translate('general.search')}
                      onChange={(e) => {
                        const { value } = e.target;
                        this.setState({ query: value });
                      }}
                    />
                  </form>
                  <Link to="/main/training" className="startTrain">
                    <p> {i18n.translate(`welcomeScreen.${userStatus}`)}</p>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </Spring>
        <ToastContainer
          draggablePercent={60}
          autoClose={false}
          newestOnTop
          rtl={false}
          pauseOnVisibilityChange
          draggable
        />
      </div>
    );
  }
}
